import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "utils/api";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { Tables } from "types/supabase";

type CreateLoanInput = {
  name: string;
  loan_type: number | undefined;
  borrower_id: string | undefined;
  property_id: number | undefined;
  property_lien_type: string | undefined;
  field_values: Record<string, any>;
};

type Loan = Tables<"loans">;

export const useCreateLoan = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateLoanInput) => {
      const response = await api.post<Loan>("/supabase/loans/insert", data);
      return response.data;
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: ["loans"], exact: false });
      return data;
    },
  });
};
